<template>

<core-card :item="item" :hasActions="true">

	<core-card-head type="game" :id="item.game.id" size="large" :data-band="ratingBand" v-if="fieldCard">

		<app-view-grid-field-insight_card 
            :item="item" 
            :field="fieldCard" 
            :filter="filter" 
        />

	</core-card-head>

	<core-card-body :grow="true" :padded="isPadded" :foot="!metricFields.length && !is.longcomment && !hasPlayReport && $currentViewContext !== 'gameplays'" v-if="fieldGame">

		<component 
            :is="primaryInsight" 
            :item="item" 
            :field="fieldGame" 
            :filter="filter" 
            v-on:longcomment="is.longcomment = $event" 
        />

	</core-card-body>

	<core-card-buttons :foot="!metricFields.length">

		<core-card-buttons-button v-on:click.native="onReadMoreClick($event)" v-if="is.longcomment">Read full comment</core-card-buttons-button>
		
        <core-card-buttons-button v-on:click.native="onReportClick" v-if="hasPlayReport">Read report</core-card-buttons-button>

        <template v-if="$currentViewContext === 'gameplays'">

		<core-card-buttons-button v-on:click.native="onStatsClick" v-if="hasStats">View more stats</core-card-buttons-button>
		
        <core-card-buttons-button v-on:click.native="onPlaysClick">View plays</core-card-buttons-button>

        </template>

	</core-card-buttons>

	<core-card-foot v-if="metricFields.length">

		<component 
            :is="fieldComponent(field)" 
            :item="item" 
            :field="field" 
            :filter="filter" 
            :key="field.id" 
            v-for="field in metricFields" 
        />

	</core-card-foot>

</core-card>

</template>

<script>

export default {

	props: ['item', 'fields', 'filter'],

    data: function() {

        return {
            is: {
                longcomment: false
            }
        }

    },

    computed: {

        hasStats: function() {

            return (this.item.record) ? this.item.record.results > 0 : false

        },

        hasPlayReport: function() {

            return (this.$currentViewContext === 'plays') ? this.item.play.comment : false

        },

        isPadded: function() {

            return this.$currentViewContext !== 'plays'

        },

		ratingBand: function() {

            if (this.$currentViewContext === 'ratings') {

			    return (this.isUser) ? Math.floor(this.item.rating.rating) : Math.floor(this.item.group.rating_avg)

            } else {

                return false

            }

		},

        primaryInsight: function() {
            
            if (this.$currentViewContext === 'ratings') {

                return 'app-view-grid-field-insight_rating'

            } else if (this.$currentViewContext === 'plays') {

                return 'app-view-grid-field-insight_play'

            } else {

                return 'app-view-grid-field-insight_game'

            }

        },

        fieldGame: function() {
            
            if (this.$currentViewContext === 'ratings') {

                return this.$_.findWhere(this.fields, {
                    type: 'insight.rating'
                })

            } else if (this.$currentViewContext === 'plays') {

                return this.$_.findWhere(this.fields, {
                    type: 'insight.play'
                })

            } else {

                return this.$_.findWhere(this.fields, {
                    type: 'insight.game'
                })

            }

        },

        fieldCard: function() {

            return this.$_.findWhere(this.fields, {
                type: 'insight.card'
            })

        },

        metricFields: function() {

            return this.$_.filter(this.fields, function(field) {

                return !field.locked

            })

        }

    },

    methods: {

        fieldComponent: function(field) {

            var component = ['app', 'view', 'grid', 'field']

            component.push(field.type.replace('.', '_'))

            return component.join('-')

        },

		onReportClick: function(e) {

			e.stopPropagation()

			this.$pubsub.$emit('panel.open', {
				type: 'playsComment',
				game: this.item.game,
				play: this.item.play,
				comment: this.item.play.comment
			})

		},

		onReadMoreClick: function(e) {

			e.stopPropagation()

			this.$pubsub.$emit('panel.open', {
				type: 'ratingsComment',
				game: this.item.game,
				rating: this.item.rating,
				comment: this.item.comment
			})
		},

		onStatsClick: function() {

			this.$pubsub.$emit('expand.open', {
				id: this.item.id,
				section: (this.isUser) ? 'opponents' : 'players'
			})

		},

		onPlaysClick: function() {

			var query = {}

			query['games.subset'] = this.item.game.id.toString()

			var filter = this.$store.getters['filter/plays']

			if (filter.played.period !== 'custom') query['played.period'] = filter.played.period
			if (filter.played.range.from) query['played.range.from'] = filter.played.range.from
			if (filter.played.range.to) query['played.range.to'] = filter.played.range.to
			if (filter.play.count.from !== 1) query['play.count.from'] = filter.play.count.from
			if (filter.play.count.to !== 10) query['play.count.to'] = filter.play.count.to
			if (filter.play.duration.from !== 0) query['play.duration.from'] = filter.play.duration.from
			if (filter.play.duration.to !== 360) query['play.duration.to'] = filter.play.duration.to
			if (filter.play.nolocation) query['play.nolocation'] = '1'
			if (filter.play.locations.length) query['play.locations'] = filter.play.locations.join(',')
			if (filter.play.players.required.length) query['play.players.required'] = filter.play.players.required.join(',')
			if (filter.play.players.together) query['play.players.together'] = '1'

			this.$routerPush({
				name: 'Plays',
				query: query
			})

		}

    }

}

</script>

<style scoped>

.card-head[data-band="10"] { border-bottom: 5px solid transparent; border-color: #249563; }
.card-head[data-band="9"] { border-bottom: 5px solid transparent; border-color: #249563; }
.card-head[data-band="8"] { border-bottom: 5px solid transparent; border-color: #2FC482; }
.card-head[data-band="7"] { border-bottom: 5px solid transparent; border-color: #1d8acd; }
.card-head[data-band="6"] { border-bottom: 5px solid transparent; border-color: #5369a2; }
.card-head[data-band="5"] { border-bottom: 5px solid transparent; border-color: #5369a2; }
.card-head[data-band="4"] { border-bottom: 5px solid transparent; border-color: #df4751; }
.card-head[data-band="3"] { border-bottom: 5px solid transparent; border-color: #df4751; }
.card-head[data-band="2"] { border-bottom: 5px solid transparent; border-color: #db303b; }
.card-head[data-band="1"] { border-bottom: 5px solid transparent; border-color: #db303b; }
.card-head[data-band="0"] { border-bottom: 5px solid transparent; border-color: #db303b; }

</style>